export default {"src":"/_next/static/media/vegan.0e5bc757.svg","height":16,"width":16};